import {
	FormControl as FormControlMui,
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './formControl.scss';

export interface FormControlProps extends ChildrenProps<HTMLDivElement> {
	fullWidth?: boolean
}

const FormControl = ({
	className,
	fullWidth=false,
	...rest
}: FormControlProps) => {
	return (
		<FormControlMui
			{...rest}
			fullWidth={fullWidth}
			className={appendClassName('sm-formcontrol', className)}/>
	)
}

export default FormControl;